import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { graphql, compose, withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import s from './RecommendListing.css';
import l from '../../Skeleton/Skeleton.css'
//Components
import SeeAll from '../SeeAll';
import HomeSlider from '../HomeSlider';
// Skeleton Loader
import Shimmer from "../../Skeleton/Shimmer";
import HomeSliderSkleton from "../../Skeleton/HomeSliderSkleton";
// Graphql
import getRecommendQuery from './getRecommend.graphql';
// Locale
import messages from '../../../locale/messages';

// Mutation for tracking impressions
const TRACK_IMPRESSIONS = gql`
  mutation trackFeaturedImpression($listIds: [Int]!) {
    trackFeaturedImpression(listIds: $listIds) {
      status
      tracked
    }
  }
`;

class RecommendListing extends React.Component {

  static propTypes = {
    getRecommendData: PropTypes.shape({
      loading: PropTypes.bool,
      getRecommendData: PropTypes.array
    })
  };

  static defaultProps = {
    getRecommendData: {
      loading: true
    }
  };

  // Track which listings we've already tracked in this session
  trackedListings = new Set();

  componentDidUpdate(prevProps) {
    const { getRecommendData, client } = this.props;

    // Only track when data first loads or changes
    if (
      !getRecommendData?.loading &&
      getRecommendData?.getRecommend?.length > 0 &&
      (prevProps.getRecommendData?.loading ||
        prevProps.getRecommendData?.getRecommend?.length !== getRecommendData.getRecommend.length)
    ) {
      this.trackImpressions(getRecommendData.getRecommend);
    }
  }

  trackImpressions = async (listings) => {
    const { client } = this.props;

    try {
      // Filter only featured listings that haven't been tracked this session
      const featuredListIds = listings
        .filter(l => l.isFeatured && !this.trackedListings.has(l.id))
        .map(l => l.id);

      if (featuredListIds.length === 0) return;

      // Mark as tracked immediately to prevent duplicate calls
      featuredListIds.forEach(id => this.trackedListings.add(id));

      // Call mutation (fire and forget - don't block UI)
      await client.mutate({
        mutation: TRACK_IMPRESSIONS,
        variables: { listIds: featuredListIds }
      });

    } catch (error) {
      // Silent fail - don't break the UI for analytics
      console.debug('[RecommendListing] Impression tracking error:', error.message);
    }
  };

  getTitleMessage = (category) => {
    switch (category) {
      case 'posada':
        return messages.recommendedPosadas; // We'll add these to messages.js next
      case 'experience':
        return messages.recommendedExperiences;
      case 'boat':
      default:
        return messages.recommended;
    }
  };

  render() {
    const { getRecommendData, skeletonArray, activeCategory } = this.props;
    const titleMessage = this.getTitleMessage(activeCategory);

    return (
      <>
        {getRecommendData && getRecommendData.loading ? <div className={s.pageContainer}>
          <div className={cx(s.container, 'containerLoaderRTL')}>
            <div className={cx(l.popularSkeletonTitle, 'bgBlackTwo')}>
              <Shimmer />
            </div>
            <div className={s.displayGrid}>
              {skeletonArray.map((n) => {
                return <HomeSliderSkleton key={n} />
              })}
            </div>
          </div>
        </div> : (
          <>
            {
              getRecommendData.getRecommend && getRecommendData.getRecommend.length > 0 && <div>
                <div className={s.container}>
                  <div className={s.sectionHeader}>
                    <h2 className={s.containerTitle}>
                      <FormattedMessage {...titleMessage} />
                    </h2>
                    <SeeAll />
                  </div>
                  <HomeSlider data={getRecommendData.getRecommend} />
                </div>
              </div>
            }
          </>
        )}
      </>
    )
  }
}

export default compose(
  injectIntl,
  withStyles(s, l),
  withApollo,
  graphql(getRecommendQuery, {
    name: 'getRecommendData',
    options: (props) => ({
      variables: {
        tier: 'standard',
        categoryType: props.activeCategory || 'boat'
      },
      ssr: false,
      fetchPolicy: 'network-only'
    })
  })
)(RecommendListing);
